import {IEmployeeListState,IEmployeeActionCreator,IEmployeeActionTypes} from 'models/IEmployeeState';

const initialState:IEmployeeListState = {
    data: [],
}

const reducer = (state = initialState, { type, payload }: IEmployeeActionCreator) => {
    switch (type) {
      case IEmployeeActionTypes.FETCH_EMPLOYEE_LIST_FAILURE:
        return {
          ...state,
          data:[],
        }
      case IEmployeeActionTypes.FETCH_EMPLOYEE_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;